import { Link, createFileRoute } from '@tanstack/react-router';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { actionsByCategory } from '@/lib/guide-structure';
import { WikiAnchorSection } from '@/components/wiki/WikiAnchorSection';
import { WikiToc } from '@/components/wiki/WikiToc';
import { GuideActionIcon } from '@/components/icons/GuideActionIcon';

export const Route = createFileRoute('/actions/')({
  component: ActionsIndexPage,
});

const categories = Object.entries(actionsByCategory);

function ActionsIndexPage() {
  const toc = categories.map(([category]) => ({
    id: category.toLowerCase().replace(/\s+/g, '-'),
    label: category,
  }));

  return (
    <div className="space-y-5">
      <WikiToc items={toc} />

      {categories.map(([category, actions]) => {
        const sectionId = category.toLowerCase().replace(/\s+/g, '-');
        return (
          <WikiAnchorSection key={category} id={sectionId} title={category}>
            <div className="mb-2 flex items-center gap-2">
              <Badge>{actions.length} actions</Badge>
              <Badge>Reference cards</Badge>
            </div>
            <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
              {actions.map(action => (
                <Link key={action.id} to="/actions/$actionId" params={{ actionId: action.id }}>
                  <Card className="h-full p-4 transition-colors hover:border-[#d4af37]/40">
                    <div className="mb-3 flex items-center gap-3">
                      <GuideActionIcon
                        action={action}
                        size="small"
                        width={56}
                        height={56}
                        className="h-14 w-14 overflow-hidden rounded-lg border border-[#d4af37]/20"
                        imgClassName="h-14 w-14 rounded-lg border border-[#d4af37]/20 object-cover"
                      />
                      <div>
                        <h3 className="font-cinzel text-lg text-[#f0f0f0]">{action.title}</h3>
                        <p className="text-xs text-[#a0a0a0]">{action.category}</p>
                      </div>
                    </div>
                    <p className="text-sm text-[#b8b8b8]">{action.summary}</p>
                  </Card>
                </Link>
              ))}
            </div>
          </WikiAnchorSection>
        );
      })}
    </div>
  );
}
